var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":"transparent","flat":""}},[_c('v-card-text',{staticClass:"pa-0 white--text"},[_c('v-icon',[_vm._v(_vm._s(_vm.message.icon || 'mdi-help'))]),_vm._v(" "+_vm._s(_vm.message.message)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }